import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import DownloadSubmissionStatusExcel from './DownloadSubmissionStatusExcel';
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadIcon.svg";
import { downLoadFile } from '../../views/pages/manage/masters/studentFinancials/paymentCollection/bulkCollection/utils';
import CustomChip from '../../views/pages/manage/common/customChip/CustomChip';
import { bulkPaymentTransferUploadStatusInfoMap } from './constants';
import { LastUpdatedDetails } from 'views/pages/manage/employeeManagement/userProfile/helper';
import { Tooltip } from '@mui/material';
import ServerDataGrid from 'views/pages/manage/common/data-grid/ServerDataGrid';
import { ReactComponent as EyeIcon } from "assets/img/svg/eyeIcon.svg";


const BulkPaymentTransferRequestsList = ({
  rows = [],
  paginationInfo,
  getBulkPaymentTransferRequestsList,
  userPermissions
}) => {

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const history = useHistory();

  console.log('rows--', rows);

  const columns = [
    {
      key: "processInstanceId",
      label: "Process ID",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">{value}</div>
          </Tooltip>
        ) : <div>-</div>
    },
    {
      key: "uploadedBy",
      label: "Uploaded By",
      sortable: true,
      width: 140,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">{value}</div>
          </Tooltip>
        ) : <div>-</div>
    },
    {
      key: "createdOn",
      label: "Uploaded On",
      sortable: true,
      width: 150,
      render: (value) =>
        value ? LastUpdatedDetails(value) : <div>-</div>
    },
    {
      key: "paymentMode",
      label: "Payment Method",
      sortable: true,
      width: 150,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">{value}</div>
          </Tooltip>
        ) : <div>-</div>
    },
       {
      key: "remark",
      label: "Remarks",
      width: 130,
      pinned: true,
      render: (value,row) =>{
        const {totalRecords,successRecords} = row || {};
        const disp = `${successRecords}/${totalRecords} Records Successfully processed`
       return  totalRecords  ? (<Tooltip title={disp}>
            <div className="ellipsis-text-container">
              {disp}
            </div>
          </Tooltip>
        ) : <div>-</div>
      }
    },
    {
      key: "status",
      label: "Status",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <CustomChip
            {...bulkPaymentTransferUploadStatusInfoMap[value]}
            style={{ textAlign: 'center' }}
          />
        ) : <div>-</div>
    },
    {
      key: "supportingDocKey",
      label: "Supporting Doc",
      width: 130,
      pinned: true,
      render: (value) =>
        value ? (
          <DownloadIcon
            className="cursor"
            onClick={() => downLoadFile(value)}
          />
        ) : <div>-</div>
    },
    ...(((userPermissions || []).includes("C") || (userPermissions || []).includes("U")) ? [{
      key: "action",
      label: "Action",
      width: 200,
      pinned: true,
      render: (_, row) => {
        const { processInstanceId, status, fileName, transferType } = row;
        return (

          <div className="d-flex align-items-center gap-2">

            {status === "COMPLETED" ? (
              <DownloadSubmissionStatusExcel
                processId={processInstanceId}
                status={status}
                fileName={fileName}
                transferType={transferType}
              />
            ) : <div>-</div>}
            <EyeIcon
              className="cursor"
              onClick={() => {
                history.push('/admin/refundTracker')
              }}
            />


          </div>);
      }
    }] : [])
  ];


  const pagination = {
    page: (paginationInfo?.currPageNo ?? 0) + 1,
    pageSize: paginationInfo?.currPageSize || 10,
    total: paginationInfo?.totalRecords || 0,
    totalPages: paginationInfo?.totalPage || 0
  };


  const handlePageChange = (newPage) => {
    const offset = newPage - 1;

    getBulkPaymentTransferRequestsList({
      offset,
      pageSize: pagination.pageSize,
      sortKey: sortConfig.key,
      sortDirection: sortConfig.direction
    });
  };


  const handlePageSizeChange = (newSize) => {
    getBulkPaymentTransferRequestsList({
      offset: 0,
      pageSize: newSize,
      sortKey: sortConfig.key,
      sortDirection: sortConfig.direction
    });
  };


  const handleSortChange = (key, direction) => {
    setSortConfig({ key, direction });

    getBulkPaymentTransferRequestsList({
      offset: 0,
      pageSize: pagination.pageSize,
      sortKey: key,
      sortDirection: direction
    });
  };

  return (
    <ServerDataGrid
      rows={rows || []}
      loading={false}

      columns={columns}
      rowKey="processId"

      pagination={pagination}
      onPageChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}

      sortConfig={sortConfig}
      onSortChange={handleSortChange}
    />
  );
};

export default BulkPaymentTransferRequestsList;
